import { Component } from '@angular/core';

@Component({
  selector: 'app-merge-pdf-file-to-one-file',
  imports: [],
  templateUrl: './merge-pdf-file-to-one-file.component.html',
  styleUrl: './merge-pdf-file-to-one-file.component.css'
})
export class MergePdfFileToOneFileComponent {

}
